<app-common-dialog-wrapper [headerText]="title" (onDialogClose)="closeModal()" [cancelButton]="cancelButton">
  <div id="search-modal">
    @if (action !== 'alternatives') {
      <div class="search-box">
        <div class="search-input">
          <mds-search-bar
            theme="light"
            [formControl]="searchText"
            placeholder="Start typing to search for pinsets"
            [hideEnterButton]="true"
          ></mds-search-bar>
        </div>
        <div class="pinset-search-select">
          <span>Search for:&nbsp;</span>
          <mds-dropdown-menu
            minWidth="222px"
            [formControl]="selectedType"
            [iconPrefix]="''"
            [options]="filterOptions"
          ></mds-dropdown-menu>
        </div>
      </div>
    }
    <section>
      <div class="results-divider">
        <div>
          @if (action !== 'alternatives') {
            <span>Search results</span>
          }
          @if (action === 'alternatives') {
            <span>Alternatives results</span>
          }
        </div>
        <hr />
      </div>
      @if (pinsetData && pinsetData.length === 0 && action !== 'alternatives') {
        <div>
          <div class="empty-trash">
            @if (action !== 'alternatives') {
              <span class="message-box">
                There are no
                @if (selected !== 'All') {
                  <span>{{ selected }}</span>
                }
                pins for this dataset. Add new
                @if (selected !== 'All') {
                  <span>{{ selected }}</span>
                }
                or search for other types of pins.
              </span>
            }
          </div>
        </div>
      }
      @if (!pinsetData && action === 'alternatives') {
        <div>
          <div class="empty-trash">
            <span>{{ this.message }}</span>
          </div>
        </div>
      }
      <perfect-scrollbar class="scroll-content">
        <div class="new-tile-container">
          @for (data of pinsetData; track data) {
            <a
              tabindex="0"
              [attr.aria-label]="data.title || data.name"
              [attr.data-disabled]="data.label"
              class="new-tile-list tile-wrap product-link"
              (click)="addFilter(data)"
              (keyup.enter)="addFilter(data)"
              >
              <mds-object-card [data]="data"
                               (menuClick)="openMenuItem($event)"
              ></mds-object-card>
            </a>
          }
        </div>
      </perfect-scrollbar>
    </section>
  </div>
</app-common-dialog-wrapper>
